import React, { useEffect,useState } from 'react';
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import CardSelect from '../../../../components/CardSelect/CardSelect';
import SelectInput from '../../../../components/SelectInput/SelectInput';
import SmashSpinner from '../../../../components/SmashSpinner/SmashSpinner';
import { usePlanForSelect } from '../../hook/usePlan';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/hooks';
import  { choosePlan, planUpgradeState } from '../../planUpgradeSlice';
import { usePlanUsage } from '../../../planUsage/hooks/usePlanUsage';
import { useCountry } from '../../../../hooks/country/useCountry';
import { billingInformationsState } from '../../../billingInformations/billingInformationsSlice';
import { discoveryState } from '../../../discovery/discoverySlice';

const ChoosePlan = () => {
    const dispatch = useAppDispatch();
    const [plansIsLoading, plans, filterByCurrency] = usePlanForSelect();
    
    const options = [{ label: 'Eur €', value: 'eur' }, { label: '$ USD', value: 'usd' }];
    const [isCountrySuccess, countries] = useCountry();
    const { billingInformation: {informations} } = useAppSelector(billingInformationsState);
    const { countryCode : discoveryCountryCode } = useAppSelector(discoveryState);

    const [defaultCurrency, setDefaultCurrency] = useState<string | undefined>();
    const {selectedPlan: {plan}} = useAppSelector(planUpgradeState);

    useEffect(() => {
        if(isCountrySuccess) {
            const currentCountry = informations?.countryCode ? countries.find(c => c.countryCode === informations?.countryCode) 
                                                                : countries.find(c => c.countryCode === discoveryCountryCode);

            if(!defaultCurrency && plan) {
                setDefaultCurrency(plan.currency);
                filterByCurrency(plan.currency);
                return
            }
            if(!defaultCurrency && currentCountry) {
                setDefaultCurrency(currentCountry.currency);
            }
        }
    }, [plan, defaultCurrency, isCountrySuccess, informations])


    const handleSelect = (id: string) => {
        dispatch(choosePlan({ planIdSelected: id }));
    }

    const [isPlanUsageLoading, apiUsageDisplay] = usePlanUsage();

    const handleChangeCurrency = ({ value }: { value: string }) => {
        filterByCurrency(value);
        setDefaultCurrency(value);
        if(apiUsageDisplay) {
            dispatch(choosePlan({ planIdSelected: apiUsageDisplay.id, defaultCurrency:value })); 
        }
    }

    // Specific when user is in Free Trial
    useEffect(() => {
        if(!plan && !isPlanUsageLoading && apiUsageDisplay && plans?.length && defaultCurrency) {
            dispatch(choosePlan({ planIdSelected: apiUsageDisplay.id, defaultCurrency })); 
        }
    }, [plan, isPlanUsageLoading, apiUsageDisplay, plans, defaultCurrency]);

    if (plansIsLoading) {
        return < SmashSpinner />;
    }

    return (
        < div >
            <CardSelect items={plans} onSelect={handleSelect} />
            <Row>
                <Col className="mt-3 d-flex justify-content-center align-items-center">
                    <SelectInput isSearchable={false} defaultValue={defaultCurrency} onChange={handleChangeCurrency} options={options} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="mt-3 fs-7 d-flex justify-content-center align-items-center">
                        <p>If you have any question, email us at <a className="link-primary" href="mailto:sales@fromsmash.com">sales@fromsmash.com</a></p>
                    </div>
                </Col>
            </Row>

        </div >
    )
}

export default ChoosePlan